module.exports = __webpack_public_path__ + "apple.2b5ac8.svg";